import type { OfflineDraftRecord } from "../../types/requisition";
import { deleteOfflineRecord, getOfflineRecord, listOfflineRecords, upsertOfflineRecord } from "./schema";

export async function saveDraft(draft: OfflineDraftRecord): Promise<void> {
  await upsertOfflineRecord("requisitionDrafts", draft.localDraftId, draft);
}

export async function getDraft(localDraftId: string): Promise<OfflineDraftRecord | undefined> {
  return getOfflineRecord<OfflineDraftRecord>("requisitionDrafts", localDraftId);
}

export async function listDrafts(): Promise<OfflineDraftRecord[]> {
  const drafts = await listOfflineRecords<OfflineDraftRecord>("requisitionDrafts");
  return drafts.sort((left, right) => left.updatedAt.localeCompare(right.updatedAt));
}

export async function deleteDraft(localDraftId: string): Promise<void> {
  await deleteOfflineRecord("requisitionDrafts", localDraftId);
}

export async function findDraftByReference(referenceId: string): Promise<OfflineDraftRecord | undefined> {
  const drafts = await listDrafts();
  return drafts.find(
    (draft) => draft.localDraftId === referenceId || draft.serverRequisitionId === referenceId,
  );
}
